var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 15.8333C1.875 17.099 2.90101 18.125 4.16667 18.125H15.8333C17.099 18.125 18.125 17.099 18.125 15.8333V4.16667C18.125 2.90101 17.099 1.875 15.8333 1.875H4.16667C2.90101 1.875 1.875 2.90101 1.875 4.16667V15.8333ZM4.16667 16.875C3.59137 16.875 3.125 16.4086 3.125 15.8333V4.16667C3.125 3.59137 3.59137 3.125 4.16667 3.125H15.8333C16.4086 3.125 16.875 3.59137 16.875 4.16667V15.8333C16.875 16.4086 16.4086 16.875 15.8333 16.875H4.16667Z",
    fill: "#4B5054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45323 7.86297C6.713 8.09027 6.73933 8.48513 6.51203 8.7449L5.41381 10L6.51203 11.2551C6.73933 11.5149 6.713 11.9097 6.45323 12.137C6.19346 12.3643 5.79861 12.338 5.57131 12.0782L4.11297 10.4116C3.90679 10.1759 3.90679 9.82408 4.11297 9.58843L5.57131 7.92177C5.79861 7.66199 6.19346 7.63567 6.45323 7.86297Z",
    fill: "#4B5054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91667 18.125C8.26184 18.125 8.54167 17.8452 8.54167 17.5V2.5C8.54167 2.15482 8.26184 1.875 7.91667 1.875C7.57149 1.875 7.29167 2.15482 7.29167 2.5V17.5C7.29167 17.8452 7.57149 18.125 7.91667 18.125Z",
    fill: "#4B5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseClose);
export default __webpack_public_path__ + "static/media/collapse-close.312ae4da8155e7bd652d3e65a8018e06.svg";
export { ForwardRef as ReactComponent };